import React from 'react';
import FieldSelect from './FieldSelect';
import SeriesLabelsControl from './workflow/SeriesLabelsControl';
import { PALETTES } from './viz/mapIcons';

// Options for a single overlay layer, dispatched by type. `numeric` are the
// value-eligible fields, `allFields` are the label/group-eligible fields.
// Options are stored on layer.options and patched back via onPatch.
const PALETTE_OPTIONS = Object.keys(PALETTES).map((k) => ({ key: k, label: k }));
const AGG_OPTIONS = ['mean', 'sum', 'min', 'max', 'count'].map((v) => ({ key: v, label: v }));

export default function LayerOptions({ layer, numeric, allFields, onPatch }) {
  const o = layer.options;
  const set = (patch) => onPatch({ options: { ...o, ...patch } });
  if (layer.type === 'dots') {
    return (
      <div className="map-options">
        <ColorField value={o.color} onChange={(v) => set({ color: v })} />
        <SizeField
          id={`${layer.id}-size`}
          label="Size"
          value={o.size}
          min={4}
          max={24}
          step={1}
          onChange={(v) => set({ size: v })}
        />
      </div>
    );
  }
  if (layer.type === 'pie') {
    return (
      <div className="map-options">
        <FieldSelect
          label="Value"
          options={numeric}
          value={o.valueField}
          onChange={(v) => set({ valueField: v })}
        />
        <FieldSelect
          label="Palette"
          options={PALETTE_OPTIONS}
          value={o.palette}
          onChange={(v) => set({ palette: v })}
        />
        <SizeField
          id={`${layer.id}-size`}
          label="Size"
          value={o.size}
          min={0.5}
          max={3}
          step={0.1}
          onChange={(v) => set({ size: v })}
        />
      </div>
    );
  }
  if (layer.type === 'bar') {
    return (
      <div className="map-options">
        <FieldSelect
          label="Value"
          options={numeric}
          value={o.valueField}
          onChange={(v) => set({ valueField: v })}
        />
        <ColorField value={o.color} onChange={(v) => set({ color: v })} />
        <SizeField
          id={`${layer.id}-size`}
          label="Size"
          value={o.size}
          min={0.5}
          max={3}
          step={0.1}
          onChange={(v) => set({ size: v })}
        />
      </div>
    );
  }
  if (layer.type === 'donuts') {
    // Distribution columns (e.g. distribution__area_bin__Large) are the primary segment source.
    const distFields = (allFields || []).filter((f) => f.key.startsWith('distribution__'));
    return (
      <div className="map-options">
        <FieldSelect
          label="Segments"
          options={distFields}
          value={o.columns || []}
          onChange={(v) => set({ columns: v })}
          multiple
        />
        <SeriesLabelsControl
          keys={o.columns || []}
          fields={distFields}
          value={o.labels || {}}
          onChange={(labels) => set({ labels })}
        />
        <FieldSelect
          label="Palette"
          options={PALETTE_OPTIONS}
          value={o.palette}
          onChange={(v) => set({ palette: v })}
        />
        <SizeField
          id={`${layer.id}-size`}
          label="Size"
          value={o.size}
          min={0.5}
          max={3}
          step={0.1}
          onChange={(v) => set({ size: v })}
        />
      </div>
    );
  }
  // labels
  return (
    <div className="map-options">
      <FieldSelect
        label="Field"
        options={allFields}
        value={o.field}
        onChange={(v) => set({ field: v })}
      />
    </div>
  );
}

function ColorField({ value, onChange }) {
  return (
    <div className="form-field">
      <input
        type="color"
        className="map-color"
        value={value}
        aria-label="Color"
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}

function SizeField({ id, label, value, min, max, step, onChange }) {
  return (
    <div className="form-field">
      <label className="form-label" htmlFor={id}>
        {label}
      </label>
      <input
        id={id}
        className="map-size-range"
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
      />
      <span className="map-size-value">{Number(value).toFixed(step < 1 ? 1 : 0)}</span>
    </div>
  );
}
